import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class DayVariantManagementApiService {

    constructor(private http: ApiHttpClient) { }


    public save(request: camps.SessionDayVariantSaveRequest): Observable<api.OperationResultValue<camps.DaysVariantDefinitionDetails>> {
        return this.http.post<api.OperationResultValue<camps.DaysVariantDefinitionDetails>>(`dayvariant`, request, true);
    }

    public remove(request: camps.SessionDayVariantRemoveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`dayvariant/remove`, request, true);
    }
}
